import {get, post, postJson} from '../axios'

const RESOURCE_BASE_PATH = '/SmsBatchMarketingSummary'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms'

// 获取人群数量
export const batchList = p => postJson(`${RESOURCE_BASE_PATH}/batchList`, p);

// 查询任务列表
export const queryList = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);

// 新增任务
export const insertTask = p => postJson(`${RESOURCE_BASE_PATH}/insertTask`, p);

// 删除任务
export const deleteTask = p => postJson(`${RESOURCE_BASE_PATH}/deleteTask`, p);

// 任务再次执行
export const updateTaskState = p => get(`${RESOURCE_BASE_PATH}/updateTaskState/${p}`);

// 获取任务信息
export const getTaskWithId = p => get(`${RESOURCE_BASE_PATH}/getTaskWithId/${p}`);

// 营销汇总-效果分析
export const getAnalyzing = p => get(`${RESOURCE_BASE_PATH}/getAnalyzing/${p}`);

// 营销汇总-客户详情
export const getActivityCompare = p => postJson(`${RESOURCE_BASE_PATH}/getActivityCompare/`, p);

// 营销汇总-商品详情
export const getAnalyzingItemDetailVoList = p => postJson(`${RESOURCE_BASE_PATH}/getAnalyzingItemDetailVoList`, p);

// 营销汇总-活动对比
export const getCompareList = p => get(`${RESOURCE_BASE_PATH}/getActivityCompare/${p}`);

